import { InputHtmlProps, ObjectValues } from '../types';

export const colors = {
  light: 'radio--light',
} as const;

export type Radio = {
  color?: ObjectValues<typeof colors>;
  description?: string;
  isUnderline?: boolean;
  label?: string;
  name: string;
  showCustomError?: boolean;
  value: string;
} & InputHtmlProps;
